import React from 'react'
import SEO from '../Component/SEO';
import ProductCard from './ProductCard';
// import Product from './Product';
import Gfooter from '../Component/Gfooter';

function NewProduct() {
    return (
        <>

            <SEO
                title="Architectural Products & Building Solutions in India | NLF"
                description="Explore NLF Solutions' architectural products including metal ceilings, facades, roofing systems, office furniture and acoustic solutions for modern spaces."
                canonical="https://nlfs.in/products"
                keywords="Architectural Products, Architectural products India, Facade products, Ceiling products, Office furniture, Roofing products, Wooden flooring, Acoustic products, Interior products, architectural products supplier in India, architectural products in Nagpur, premium architectural products India"
            />
            <h1 className="seo-h1">Architectural Products for Modern Spaces</h1>
            <ProductCard />
            {/* <Product/> */}
            <Gfooter />
        </>
    );
}

export default NewProduct;